/**
 * CoinFrenzyAnimation Class
 *
 *
 */

(function () {
  class CoinFrenzyAnimation extends PIXI.Container {
    constructor() {
      super();

      this._hasAnimFinished = false;
      this._initialised = false;
    }

    hasAnimFinished() {
      return this._hasAnimFinished;
    }

    createAndApplyMask() {
      const mask = new PIXI.Graphics();
      mask.beginFill(0xff0000, 1);
      mask.drawRect(0, 0, 624, 413);
      mask.endFill();
      mask.x = -313;
      mask.y = -205;
      this.mask = mask;
      this.addChild(mask);
    }

    grabReferences() {
      this._coinFrenzyGold0CoinParticleContainer = resourceManager.get(
        'mainReelsContainer:coinFrenzyAnimation:CoinFrenzyAnimation:coinFrenzyCoinsContainer:coinFrenzyGold0CoinContainer:coinFrenzyGold0CoinParticleContainer'
      );
      this._coinFrenzyGold1CoinParticleContainer = resourceManager.get(
        'mainReelsContainer:coinFrenzyAnimation:CoinFrenzyAnimation:coinFrenzyCoinsContainer:coinFrenzyGold1CoinContainer:coinFrenzyGold1CoinParticleContainer'
      );
      this._coinFrenzyGreenCoinParticleContainer = resourceManager.get(
        'mainReelsContainer:coinFrenzyAnimation:CoinFrenzyAnimation:coinFrenzyCoinsContainer:coinFrenzyGreenCoinContainer:coinFrenzyGreenCoinParticleContainer'
      );
      this._coinFrenzyRedCoinParticleContainer = resourceManager.get(
        'mainReelsContainer:coinFrenzyAnimation:CoinFrenzyAnimation:coinFrenzyCoinsContainer:coinFrenzyRedCoinContainer:coinFrenzyRedCoinParticleContainer'
      );
      this._coinFrenzyBlueCoinParticleContainer = resourceManager.get(
        'mainReelsContainer:coinFrenzyAnimation:CoinFrenzyAnimation:coinFrenzyCoinsContainer:coinFrenzyBlueCoinContainer:coinFrenzyBlueCoinParticleContainer'
      );
      this._coinFrenzyTitle = resourceManager.get(
        'mainReelsContainer:coinFrenzyAnimation:CoinFrenzyAnimation:coinFrenzyTitle'
      );
      this._goldCoin0 = resourceManager.get(
        'mainReelsContainer:coinFrenzyAnimation:CoinFrenzyAnimation:coinFrenzyCoinsContainer:coinFrenzyGold0CoinContainer:coinFrenzyGold0Coin'
      );
      this._greenCoin = resourceManager.get(
        'mainReelsContainer:coinFrenzyAnimation:CoinFrenzyAnimation:coinFrenzyCoinsContainer:coinFrenzyGreenCoinContainer:coinFrenzyGreenCoin'
      );
      this._goldCoin1 = resourceManager.get(
        'mainReelsContainer:coinFrenzyAnimation:CoinFrenzyAnimation:coinFrenzyCoinsContainer:coinFrenzyGold1CoinContainer:coinFrenzyGold1Coin'
      );
      this._redCoin = resourceManager.get(
        'mainReelsContainer:coinFrenzyAnimation:CoinFrenzyAnimation:coinFrenzyCoinsContainer:coinFrenzyRedCoinContainer:coinFrenzyRedCoin'
      );
      this._blueCoin = resourceManager.get(
        'mainReelsContainer:coinFrenzyAnimation:CoinFrenzyAnimation:coinFrenzyCoinsContainer:coinFrenzyBlueCoinContainer:coinFrenzyBlueCoin'
      );
    }

    createAndAddEmitters() {
      // gold
      const cf_Gold0CoinEmitter = particleManager.createEmitter(
        'cf_GoldCoinEmitter',
        this._coinFrenzyGold0CoinParticleContainer,
        0,
        0,
        false
      );
      cf_Gold0CoinEmitter.particleEmitter.emit = false;
      cf_Gold0CoinEmitter.visible = false;
      this._coinFrenzyGold0CoinParticleContainer.emitter = cf_Gold0CoinEmitter;
      // green
      const cf_GreenCoinEmitter = particleManager.createEmitter(
        'cf_GreenCoinEmitter',
        this._coinFrenzyGreenCoinParticleContainer,
        0,
        0,
        false
      );
      cf_GreenCoinEmitter.particleEmitter.emit = false;
      cf_GreenCoinEmitter.visible = false;
      this._coinFrenzyGreenCoinParticleContainer.emitter = cf_GreenCoinEmitter;
      // gold
      const cf_Gold1CoinEmitter = particleManager.createEmitter(
        'cf_GoldCoinEmitter',
        this._coinFrenzyGold1CoinParticleContainer,
        0,
        0,
        false
      );
      cf_Gold1CoinEmitter.particleEmitter.emit = false;
      cf_Gold1CoinEmitter.visible = false;
      this._coinFrenzyGold1CoinParticleContainer.emitter = cf_Gold1CoinEmitter;
      // red
      const cf_RedCoinEmitter = particleManager.createEmitter(
        'cf_RedCoinEmitter',
        this._coinFrenzyRedCoinParticleContainer,
        0,
        0,
        false
      );
      cf_RedCoinEmitter.particleEmitter.emit = false;
      cf_RedCoinEmitter.visible = false;
      this._coinFrenzyRedCoinParticleContainer.emitter = cf_RedCoinEmitter;
      // blue
      const cf_BlueCoinEmitter = particleManager.createEmitter(
        'cf_BlueCoinEmitter',
        this._coinFrenzyBlueCoinParticleContainer,
        0,
        0,
        false
      );
      cf_BlueCoinEmitter.particleEmitter.emit = false;
      cf_BlueCoinEmitter.visible = false;
      this._coinFrenzyBlueCoinParticleContainer.emitter = cf_BlueCoinEmitter;
    }

    async animateCoinFrenzyTitle() {
      await game.tweenFromToAsync(
        this._coinFrenzyTitle,
        {
          y: -390,
        },
        {
          y: 0,
          ease: 'back.out',
          duration: 0.35,
        }
      );

      const coinsDroppingPromise = this.dropCoinsTwice();

      await game.tweenFromToAsync(
        this._coinFrenzyTitle.scale,
        {
          x: 1,
          y: 1,
        },
        {
          x: 1.2,
          y: 1.2,
          repeat: 1,
          yoyo: true,
          ease: 'none',
          duration: 0.15,
        }
      );

      await timerManager.delayAsync(500);

      await game.tweenFromToAsync(
        this._coinFrenzyTitle,
        {
          y: 0,
        },
        {
          y: 390,
          ease: 'back.in',
          duration: 0.35,
        }
      );

      await coinsDroppingPromise;
    }

    async dropCoinsTwice() {
      const drop1 = this.animateCoinsDropping(true);
      await timerManager.delayAsync(1000);
      const drop2 = this.animateCoinsDropping(false);
      await Promise.all([drop1, drop2]);
    }

    async stopEmitters() {
      this._coinFrenzyGold1CoinParticleContainer.emitter.particleEmitter.emit = false;
      this._coinFrenzyGold0CoinParticleContainer.emitter.particleEmitter.emit = false;
      this._coinFrenzyGreenCoinParticleContainer.emitter.particleEmitter.emit = false;
      this._coinFrenzyBlueCoinParticleContainer.emitter.particleEmitter.emit = false;
      this._coinFrenzyRedCoinParticleContainer.emitter.particleEmitter.emit = false;

      await timerManager.delayAsync(500);
      this._coinFrenzyGold0CoinParticleContainer.emitter.visible = false;
      this._coinFrenzyGold1CoinParticleContainer.emitter.visible = false;
      this._coinFrenzyGreenCoinParticleContainer.emitter.visible = false;
      this._coinFrenzyRedCoinParticleContainer.emitter.visible = false;
      this._coinFrenzyBlueCoinParticleContainer.emitter.visible = false;
    }

    async animateCoinsDropping(first = true) {
      const dropDuration = 1.2;
      const startY = -300;
      const endY = 400;

      // middle coin 1st
      this._coinFrenzyGold1CoinParticleContainer.emitter.particleEmitter.spawnPos.y = -300;
      this._coinFrenzyGold1CoinParticleContainer.emitter.particleEmitter.emit = true;
      this._coinFrenzyGold1CoinParticleContainer.emitter.visible = true;
      const goldCoin1Promise = game.tweenFromToAsync(
        [this._goldCoin1, this._coinFrenzyGold1CoinParticleContainer.emitter.particleEmitter.spawnPos],
        {
          y: startY,
        },
        {
          y: endY,
          duration: dropDuration,
          ease: 'none',
          onComplete: () => {
            // this._coinFrenzyGold1CoinParticleContainer.emitter.particleEmitter.emit = false;
          },
        }
      );

      await timerManager.delayAsync(250);

      this._coinFrenzyGold0CoinParticleContainer.emitter.particleEmitter.spawnPos.y = startY;
      this._coinFrenzyGold0CoinParticleContainer.emitter.particleEmitter.emit = true;
      this._coinFrenzyGold0CoinParticleContainer.emitter.visible = true;
      const goldCoin0Promise = game.tweenFromToAsync(
        [this._goldCoin0, this._coinFrenzyGold0CoinParticleContainer.emitter.particleEmitter.spawnPos],
        {
          y: startY,
        },
        {
          y: endY,
          duration: dropDuration,
          ease: 'none',
          onComplete: () => {
            // this._coinFrenzyGold0CoinParticleContainer.emitter.particleEmitter.emit = false;
          },
        }
      );

      await timerManager.delayAsync(100);

      this._coinFrenzyGreenCoinParticleContainer.emitter.particleEmitter.spawnPos.y = startY;
      this._coinFrenzyGreenCoinParticleContainer.emitter.particleEmitter.emit = true;
      this._coinFrenzyGreenCoinParticleContainer.emitter.visible = true;
      const greenCoinPromise = game.tweenFromToAsync(
        [this._greenCoin, this._coinFrenzyGreenCoinParticleContainer.emitter.particleEmitter.spawnPos],
        {
          y: startY,
        },
        {
          y: endY,
          duration: dropDuration,
          ease: 'none',
          onComplete: () => {
            // this._coinFrenzyGreenCoinParticleContainer.emitter.particleEmitter.emit = false;
          },
        }
      );

      await timerManager.delayAsync(250);

      this._coinFrenzyBlueCoinParticleContainer.emitter.particleEmitter.spawnPos.y = startY;
      this._coinFrenzyBlueCoinParticleContainer.emitter.particleEmitter.emit = true;
      this._coinFrenzyBlueCoinParticleContainer.emitter.visible = true;
      const blueCoinPromise = game.tweenFromToAsync(
        [this._blueCoin, this._coinFrenzyBlueCoinParticleContainer.emitter.particleEmitter.spawnPos],
        {
          y: startY,
        },
        {
          y: endY,
          duration: dropDuration,
          ease: 'none',
          onComplete: () => {
            // this._coinFrenzyBlueCoinParticleContainer.emitter.particleEmitter.emit = false;
          },
        }
      );

      await timerManager.delayAsync(100);

      this._coinFrenzyRedCoinParticleContainer.emitter.particleEmitter.spawnPos.y = startY;
      this._coinFrenzyRedCoinParticleContainer.emitter.particleEmitter.emit = true;
      this._coinFrenzyRedCoinParticleContainer.emitter.visible = true;
      const redCoinPromise = game.tweenFromToAsync(
        [this._redCoin, this._coinFrenzyRedCoinParticleContainer.emitter.particleEmitter.spawnPos],
        {
          y: startY,
        },
        {
          y: endY,
          duration: dropDuration,
          ease: 'none',
          onComplete: () => {
            // this._coinFrenzyRedCoinParticleContainer.emitter.particleEmitter.emit = false;
          },
        }
      );

      await Promise.all([goldCoin0Promise, greenCoinPromise, goldCoin1Promise, redCoinPromise, blueCoinPromise]);

      // wait enough time for the last emitter to finish outputting or hopefully far enough off screen
      if (!first) {
        await this.stopEmitters();
      }
    }

    async presentCoinFrenzyAnimation() {
      this._hasAnimFinished = false;

      if (!this._initialised) {
        this.init();
      }

      // delay to build anticipation
      await timerManager.delayAsync(1300);

      // dim all symbols
      gameController.slotMachine.dimAllSymbols(true, 0.2);
      gameController.symbolOverlayDisplay.dimAllSymbols(true, 0.2);

      // wait for symbols to dim
      await timerManager.delayAsync(200);

      musicManager.playCoinFrenzySFX();

      // move and scale title
      this.visible = true;
      // we also need to start off the coins dropping along with emitters
      await this.animateCoinFrenzyTitle();

      this.visible = false;

      gameController.slotMachine.dimAllSymbols(false, 0.1);
      gameController.symbolOverlayDisplay.dimAllSymbols(false, 0.1);

      this._hasAnimFinished = true;
    }

    init() {
      if (!this._initialised) {
        this.grabReferences();
        this.createAndApplyMask();
        this.createAndAddEmitters();
        this._initialised = true;
      }
    }
  }

  var creator = function (json) {
    return new CoinFrenzyAnimation();
  };

  var initialiser = function (json, container) {};

  var filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('CoinFrenzyAnimation', creator, initialiser, filesRequired);
})();
